import { useEffect, useState } from 'react';
import SplitLandingPage from './splitLanding/SplitLandingPage';

interface GeoRedirectProps {
  children: React.ReactNode;
}

const GeoRedirect = ({ children }: GeoRedirectProps) => {
  const [showSplitPage, setShowSplitPage] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkCountry = async () => {
      try {
        // 🧪 테스트 모드: URL 파라미터로 강제 설정
        const urlParams = new URLSearchParams(window.location.search);
        const testCountry = urlParams.get('test-country');

        if (testCountry) {
          console.log(`🧪 테스트 모드: 국가를 ${testCountry}로 설정`);
          if (testCountry !== 'KR') {
            setShowSplitPage(true);
          }
          setIsLoading(false);
          return;
        }

        // Vercel에서 제공하는 국가 정보 확인
        const country = document
          .querySelector('meta[name="x-vercel-ip-country"]')
          ?.getAttribute('content');

        // 또는 IP 기반 국가 확인 API 사용 (백업)
        if (!country) {
          const response = await fetch('https://ipapi.co/json/');
          const data = await response.json();

          if (data.country_code && data.country_code !== 'KR') {
            setShowSplitPage(true);
          }
        } else if (country !== 'KR') {
          setShowSplitPage(true);
        }
      } catch (error) {
        console.error('Geo check failed:', error);
        // 에러 발생 시 기본적으로 한국 사용자로 간주
      } finally {
        setIsLoading(false);
      }
    };

    checkCountry();
  }, []);

  const handleSelectKorea = () => {
    setShowSplitPage(false);
  };

  // 로딩 중이면 아무것도 렌더링하지 않음
  if (isLoading) {
    return null;
  }

  // 외국인이면 SplitLandingPage 표시
  if (showSplitPage) {
    return <SplitLandingPage onSelectKorea={handleSelectKorea} />;
  }

  // 한국인이면 기존 앱 표시
  return <>{children}</>;
};

export default GeoRedirect;
